import React, { useState } from 'react';
import { Phone, Mail, MapPin, Printer, Send } from 'lucide-react';
export function ContactSection() {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formState);
    alert('Thank you for your request. We will contact you shortly.');
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value
    });
  };
  return <section id="contact" className="py-24 bg-steel relative z-10" data-id="element-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-41">
        <div className="text-center mb-16" data-id="element-42">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white uppercase mb-4" data-id="element-43">
            Ready to Schedule a Survey?
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto font-light" data-id="element-44">
            Our Gulf Coast team is ready to respond immediately to your marine
            surveying needs.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16" data-id="element-45">
          {/* Contact Info */}
          <div className="text-white space-y-8" data-id="element-46">
            <div className="bg-navy/30 p-8 border border-white/10 backdrop-blur-sm" data-id="element-47">
              <h3 className="text-xl font-heading font-bold text-accent uppercase mb-6 tracking-wider" data-id="element-48">
                Contact Information
              </h3>

              <div className="space-y-6" data-id="element-49">
                <div className="flex items-start" data-id="element-50">
                  <Phone className="w-6 h-6 text-accent mr-4 mt-1 flex-shrink-0" data-id="element-51" />
                  <div data-id="element-52">
                    <p className="font-bold uppercase text-sm text-gray-400 mb-1" data-id="element-53">
                      Port Arthur Office
                    </p>
                    <a href="tel:409-727-1607" className="text-xl font-medium hover:text-accent transition-colors" data-id="element-54">
                      409-727-1607
                    </a>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-55">
                  <Phone className="w-6 h-6 text-accent mr-4 mt-1 flex-shrink-0" data-id="element-56" />
                  <div data-id="element-57">
                    <p className="font-bold uppercase text-sm text-gray-400 mb-1" data-id="element-58">
                      Houston Office
                    </p>
                    <a href="tel:713-782-5445" className="text-xl font-medium hover:text-accent transition-colors" data-id="element-59">
                      713-782-5445
                    </a>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-60">
                  <Printer className="w-6 h-6 text-accent mr-4 mt-1 flex-shrink-0" data-id="element-61" />
                  <div data-id="element-62">
                    <p className="font-bold uppercase text-sm text-gray-400 mb-1" data-id="element-63">
                      Fax
                    </p>
                    <span className="text-lg" data-id="element-64">409-727-1875</span>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-65">
                  <Mail className="w-6 h-6 text-accent mr-4 mt-1 flex-shrink-0" data-id="element-66" />
                  <div data-id="element-67">
                    <p className="font-bold uppercase text-sm text-gray-400 mb-1" data-id="element-68">
                      Email
                    </p>
                    <a href="mailto:hstark@djs-marinesurveyors.com" className="text-lg hover:text-accent transition-colors break-all" data-id="element-69">
                      hstark@djs-marinesurveyors.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-70">
                  <MapPin className="w-6 h-6 text-accent mr-4 mt-1 flex-shrink-0" data-id="element-71" />
                  <div data-id="element-72">
                    <p className="font-bold uppercase text-sm text-gray-400 mb-1" data-id="element-73">
                      Corporate Office
                    </p>
                    <span className="text-lg block" data-id="element-74">
                      211 S. Hwy 69, Nederland, TX 77627
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-white p-8 shadow-2xl" data-id="element-75">
            <h3 className="text-2xl font-heading font-bold text-navy uppercase mb-6" data-id="element-76">
              Send Us a Message
            </h3>
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-77">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-78">
                <div data-id="element-79">
                  <label htmlFor="name" className="block text-sm font-bold text-gray-700 uppercase tracking-wider mb-2" data-id="element-80">
                    Name
                  </label>
                  <input type="text" id="name" name="name" required className="w-full px-4 py-3 bg-gray-50 border border-gray-300 focus:border-accent focus:ring-1 focus:ring-accent outline-none transition-colors" placeholder="Your Name" onChange={handleChange} data-id="element-81" />
                </div>
                <div data-id="element-82">
                  <label htmlFor="phone" className="block text-sm font-bold text-gray-700 uppercase tracking-wider mb-2" data-id="element-83">
                    Phone
                  </label>
                  <input type="tel" id="phone" name="phone" required className="w-full px-4 py-3 bg-gray-50 border border-gray-300 focus:border-accent focus:ring-1 focus:ring-accent outline-none transition-colors" placeholder="Your Phone Number" onChange={handleChange} data-id="element-84" />
                </div>
              </div>

              <div data-id="element-85">
                <label htmlFor="email" className="block text-sm font-bold text-gray-700 uppercase tracking-wider mb-2" data-id="element-86">
                  Email
                </label>
                <input type="email" id="email" name="email" required className="w-full px-4 py-3 bg-gray-50 border border-gray-300 focus:border-accent focus:ring-1 focus:ring-accent outline-none transition-colors" placeholder="your.email@company.com" onChange={handleChange} data-id="element-87" />
              </div>

              <div data-id="element-88">
                <label htmlFor="service" className="block text-sm font-bold text-gray-700 uppercase tracking-wider mb-2" data-id="element-89">
                  Service Needed
                </label>
                <select id="service" name="service" className="w-full px-4 py-3 bg-gray-50 border border-gray-300 focus:border-accent focus:ring-1 focus:ring-accent outline-none transition-colors" onChange={handleChange} data-id="element-90">
                  <option value="" data-id="element-91">Select a Service...</option>
                  <option value="appraisal" data-id="element-92">Appraisal</option>
                  <option value="cargo" data-id="element-93">Cargo Survey</option>
                  <option value="damage" data-id="element-94">Damage Assessment</option>
                  <option value="audit" data-id="element-95">Audit / Consulting</option>
                  <option value="other" data-id="element-96">Other</option>
                </select>
              </div>

              <div data-id="element-97">
                <label htmlFor="message" className="block text-sm font-bold text-gray-700 uppercase tracking-wider mb-2" data-id="element-98">
                  Message
                </label>
                <textarea id="message" name="message" rows={4} required className="w-full px-4 py-3 bg-gray-50 border border-gray-300 focus:border-accent focus:ring-1 focus:ring-accent outline-none transition-colors resize-none" placeholder="How can we help you?" onChange={handleChange} data-id="element-99"></textarea>
              </div>

              <button type="submit" className="w-full bg-accent hover:bg-red-700 text-white font-bold uppercase tracking-wider py-4 px-8 transition-colors duration-300 shadow-lg flex items-center justify-center" data-id="element-100">
                Send Request <Send className="ml-2 w-4 h-4" data-id="element-101" />
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>;
}